
import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { useStoreNavigate } from '@/hooks/use-app-navigate';

interface PostPurchaseResourceBadgeProps {
    postPurchaseId: string;
    variant?: 'default' | 'secondary' | 'destructive' | 'outline';
    className?: string;
}

/**
 * PaymentResourceBadge component for displaying payment information
 * Inherits from generic ResourceBadge
 */
export function PostPurchaseResourceBadge({
    postPurchaseId,
    variant = 'secondary',
    className,
}: PostPurchaseResourceBadgeProps) {
    const { storeRoutes } = useStoreNavigate();
    // Format display value based on available data
    const displayValue = React.useMemo(() => {
        return `${postPurchaseId.substring(0, 8)}...`;
    }, [postPurchaseId]);

    return (
        <ResourceBadge
            name="variant"
            value={displayValue}
            appLink={storeRoutes.POST_PURCHASE_EDIT(postPurchaseId)}
            variant={variant}
            className={className}
        />
    );
}

